import { GamePlayData } from '../types'

export const SURF_MINUTES_PER_ENERGY = 3
export const WORK_MINUTES_PER_ENERGY = 20
export const BASE_GAME_MINUTES_PER_TICK = 4
export const TICK_INTERVAL_MILLISECONDS = 100
export const BASE_ENERGY_REGENERATION_PER_HOUR = 0.84
export const BASE_MAX_ENERGY = 20
export const MIN_ENERGY_FOR_ACTIVITY_START = 5
export const ENERGY_PER_FITNESS_LEVEL = 20
export const SURF_GAME_SPEED_SLOWDOWN = 10
export const GAME_SAVE_INTERVAL = 30 * 1000
export const SKILL_LEVEL_CAP = 5
